import { useTranslation } from 'react-i18next';
import { Button, Input } from '@artosera/ui';
import type { TypeRdvEntree } from '@artosera/shared';
import styles from './RendezVous.module.css';

export function PlagesEditeur({
  plages,
  onChange,
}: {
  plages: TypeRdvEntree['plages'];
  onChange: (plages: TypeRdvEntree['plages']) => void;
}) {
  const { t } = useTranslation('regie');
  return (
    <div className={styles.formulaire}>
      <h3>{t('priseRendezVous.plages')}</h3>
      {Array.from({ length: 7 }, (_, i) => i + 1).map((jour) => (
        <fieldset className={styles.bloc} key={jour}>
          <legend>{t(`priseRendezVous.jours.${jour}`)}</legend>
          {plages.map((p, index) =>
            p.jour === jour ? (
              <div className={styles.plage} key={index}>
                <label className={styles.champ}>
                  {t('priseRendezVous.debutPlage', {
                    numero: plages.slice(0, index).filter((p) => p.jour === jour).length + 1,
                  })}
                  <Input
                    type="time"
                    required
                    value={p.debut}
                    onChange={(e) =>
                      onChange(
                        plages.map((p, i) => (i === index ? { ...p, debut: e.target.value } : p)),
                      )
                    }
                  />
                </label>
                <label className={styles.champ}>
                  {t('priseRendezVous.finPlage', {
                    numero: plages.slice(0, index).filter((p) => p.jour === jour).length + 1,
                  })}
                  <Input
                    type="time"
                    required
                    value={p.fin}
                    onChange={(e) =>
                      onChange(
                        plages.map((p, i) => (i === index ? { ...p, fin: e.target.value } : p)),
                      )
                    }
                  />
                </label>
                <Button
                  variant="ghost"
                  onClick={() => onChange(plages.filter((_, i) => i !== index))}
                >
                  {t('priseRendezVous.retirerPlage', {
                    numero: plages.slice(0, index).filter((p) => p.jour === jour).length + 1,
                  })}
                </Button>
              </div>
            ) : null,
          )}
          <Button
            variant="secondary"
            disabled={plages.filter((p) => p.jour === jour).length >= 6}
            onClick={() => onChange([...plages, { jour, debut: '09:00', fin: '12:00' }])}
          >
            {t('priseRendezVous.ajouterPlage')}
          </Button>
        </fieldset>
      ))}
      <p>{t('priseRendezVous.plagesAide')}</p>
    </div>
  );
}
